"use client";
import { Progress, Flex, Divider, Select, Image } from "antd";
import { useState, useEffect } from "react";
import { productReviewPage } from "@/service/index/index";
import { ProductProps } from "@/types/index";
import { RateCustom } from "@/app/components/common/RateCustom/index";
import { CustomPagination } from "@/app/components/common/CustomPagination";
import "./style/index.css";
import useMobileDetect from "@/hooks/useMobileDetect";
const { PreviewGroup } = Image;

type ProducReviews = {
  content: string;
  createTime: string;
  createTimeStr: string;
  picture: string[];
  saleAttr: { color?: string; size?: string };
  score: number;
  userName: string;
};

export type ProductPriceProps = {
  productData: ProductProps;
};
export const Reviews: React.FC<ProductPriceProps> = ({
  productData,
  ...props
}) => {
  const isMobile = useMobileDetect();
  const [reviewListPage, setReviewListPage] = useState({
    current: 1,
    pageSize: 10,
    sort: 0,
  });

  const [reviewListData, setReviewListData] = useState({
    pages: 1,
    records: [],
    size: 0,
    total: 0,
  });

  useEffect(() => {
    getList();
  }, [reviewListPage]);

  const getList = () => {
    // console.log("productData.spuId : ", productData.spuId)
    productReviewPage({
      productId: productData.spuId,
      ...reviewListPage,
    }).then((res) => {
      if (res.status === 200) {
        setReviewListData({ ...res.data });
      }
    });
  };

  const oneStarPercentage =
    (productData.oneStar / productData.reviewCount) * 100;
  const twoStarPercentage =
    (productData.twoStar / productData.reviewCount) * 100;
  const threeStarPercentage =
    (productData.threeStar / productData.reviewCount) * 100;
  const fourStarPercentage =
    (productData.fourStar / productData.reviewCount) * 100;
  const fiveStarPercentage =
    (productData.fiveStar / productData.reviewCount) * 100;

  return reviewListData.total ? (
    <div className="reviews_self">
      <div className="mb-24 text-2xl font-bold leading-28 text-bravve-100 lg:mb-36">
        Ratings & Reviews
      </div>
      <Flex justify="space-between" className="flex-col md:flex-row">
        <Flex align="center" gap={10} className="mb-8 lg:flex-col">
          <div className="text-[48px] font-bold leading-[56px] text-bravve-100">
            {productData.rating}
          </div>
          <div className="text-bravve-sub-100">
            <div>
              <RateCustom
                value={productData.rating ? parseFloat(productData.rating) : 0}
              />
            </div>
            <div className="leading-22">{productData.reviewCount} Reviews</div>
          </div>
        </Flex>
        {/* <div className="text-bravve-sub-300">Recommended value <span className="text-bravve-100">88%</span></div>
          <div className="text-bravve-sub-300">1846 reviewers recommend this product</div> */}
        {/* <div className="shrink basis-72 max-w-[72px]"></div> ml-20 grow shrink basis-370 max-w-[370px] */}
        <div className="x1:ml-80 mt-24 min-w-[200px] shrink grow md:mt-0 md:max-w-[370px] lg:ml-40">
          <Flex align="center">
            <span className="w-14 leading-22 text-bravve-100">5</span>
            <iconpark-icon
              name="starzhuangtaimanxing"
              icon-id="starzhuangtaimanxing"
              size="1.6rem"
              class="ml-4 mr-15 mt-[-2px]"
            ></iconpark-icon>
            <Progress
              strokeLinecap="butt"
              strokeColor="#402C22"
              percent={fiveStarPercentage}
              showInfo={false}
              size={{ height: 12 }}
              style={{ lineHeight: "0.8", width: isMobile ? 256 : 280 }}
            />
            <div className="ml-12 leading-22 text-bravve-100">
              {productData.fiveStar}
            </div>
          </Flex>
          <Flex align="center">
            <span className="w-14 leading-22 text-bravve-100">4</span>
            <iconpark-icon
              name="starzhuangtaimanxing"
              icon-id="starzhuangtaimanxing"
              size="1.6rem"
              class="ml-4 mr-15 mt-[-2px]"
            ></iconpark-icon>
            <Progress
              strokeLinecap="butt"
              strokeColor="#402C22"
              percent={fourStarPercentage}
              showInfo={false}
              size={{ height: 12 }}
              style={{ lineHeight: "0.8", width: isMobile ? 256 : 280 }}
            />
            <div className="ml-12 leading-22 text-bravve-100">
              {productData.fourStar}
            </div>
          </Flex>
          <Flex align="center">
            <span className="w-14 leading-22 text-bravve-100">3</span>
            <iconpark-icon
              name="starzhuangtaimanxing"
              icon-id="starzhuangtaimanxing"
              size="1.6rem"
              class="ml-4 mr-15 mt-[-2px]"
            ></iconpark-icon>
            <Progress
              strokeLinecap="butt"
              strokeColor="#402C22"
              percent={threeStarPercentage}
              showInfo={false}
              size={{ height: 12 }}
              style={{ lineHeight: "0.8", width: isMobile ? 256 : 280 }}
            />
            <div className="ml-12 leading-22 text-bravve-100">
              {productData.threeStar}
            </div>
          </Flex>
          <Flex align="center">
            <span className="w-14 leading-22 text-bravve-100">2</span>
            <iconpark-icon
              name="starzhuangtaimanxing"
              icon-id="starzhuangtaimanxing"
              size="1.6rem"
              class="ml-4 mr-15 mt-[-2px]"
            ></iconpark-icon>
            <Progress
              strokeLinecap="butt"
              strokeColor="#402C22"
              percent={twoStarPercentage}
              showInfo={false}
              size={{ height: 12 }}
              style={{ lineHeight: "0.8", width: isMobile ? 256 : 280 }}
            />
            <div className="ml-12 leading-22 text-bravve-100">
              {productData.twoStar}
            </div>
          </Flex>
          <Flex align="center">
            <span className="w-14 leading-22 text-bravve-100">1</span>
            <iconpark-icon
              name="starzhuangtaimanxing"
              icon-id="starzhuangtaimanxing"
              size="1.6rem"
              class="ml-4 mr-15 mt-[-2px]"
            ></iconpark-icon>
            <Progress
              strokeLinecap="butt"
              strokeColor="#402C22"
              percent={oneStarPercentage}
              showInfo={false}
              size={{ height: 12 }}
              style={{ lineHeight: "0.8", width: isMobile ? 256 : 280 }}
            />
            <div className="ml-12 leading-22 text-bravve-100">
              {productData.oneStar}
            </div>
          </Flex>
        </div>
      </Flex>

      <Divider className="my-24" />

      <Flex
        className="mb-24 flex justify-between leading-22 text-bravve-sub-100"
        justify="space-between"
        align="center"
      >
        <span>{reviewListData.total} reviews</span>
        <Flex justify="space-between" align="center" gap={8}>
          <span>Sort by:</span>
          <Select
            size="large"
            defaultValue={0}
            style={{ width: isMobile ? 160 : 200, height: 38 }}
            onChange={(value) => {
              setReviewListPage({
                ...reviewListPage,
                sort: value,
              });
            }}
            options={[
              { value: 0, label: "Recommend" },
              { value: 1, label: "Most Recent to Oldest" },
            ]}
          />
        </Flex>
      </Flex>

      {reviewListData.records.map((item: ProducReviews, idx: number) => {
        return (
          <div key={"review" + idx}>
            <Flex align="center" justify="space-between">
              <Flex align="center" gap={10}>
                <span className="text-lg font-bold text-bravve-100 leading-24">{item.userName}</span>
                {/* <span className="text-bravve-sub-100">in London</span> */}
              </Flex>
              <span className="text-bravve-sub-100 leading-22">{item.createTimeStr}</span>
            </Flex>

            <div className="my-16">
              <RateCustom value={item.score} />
            </div>

            <Flex align="center" gap={16}>
              {Object.keys(item.saleAttr).map((key: string) => {
                return (
                  <span key={key} className="flex items-center leading-22">
                    <span className="firstLetterUppercase text-bravve-sub-100">
                      {key}：
                    </span>
                    <span className="text-bravve-100">{item.saleAttr[key as keyof typeof item.saleAttr]}</span>
                  </span>
                );
              })}
              {/* {
                item.saleAttr.color && (<span>
                  <span className="text-bravve-sub-100">Color：</span>{item.saleAttr.color}
                </span>)
              }
              
              {
                item.saleAttr.size && (<span>
                  <span className="text-bravve-sub-100">Size：</span>{item.saleAttr.size}
                </span>)
              } */}
            </Flex>
            <div className="mt-8 text-lg text-bravve-100 leading-24 ">
              {item.content}
            </div>
            <Flex gap={10} className="mt-16 overflow-x-auto">
              <PreviewGroup
                preview={
                  {
                    // onChange: (current, prev) => console.log(`current index: ${current}, prev index: ${prev}`),
                  }
                }
              >
                {item.picture.map((item: string) => {
                  return (
                    <Image
                      key={item}
                      width={isMobile ? 96 : 160}
                      className="rounded-md"
                      loading="lazy"
                      alt={productData.name + " review image"}
                      src={process.env.NEXT_PUBLIC_IMAGE_URL + item}
                      style={{borderRadius: 2}}
                    />
                  );
                })}
              </PreviewGroup>
            </Flex>
            <Divider className="my-24" />
          </div>
        );
      })}

      <CustomPagination
        total={reviewListData.total}
        pageSize={reviewListPage.pageSize}
        current={reviewListPage.current}
        onChange={(page, pageSize) => {
          // console.log("page, pageSize ： ", page, pageSize);
          setReviewListPage({
            ...reviewListPage,
            current: page,
            pageSize: pageSize,
          });
        }}
      />
    </div>
  ) : null;
};
